import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useBreakpointUp } from '@travel-frontend/core';
import { IconSearch } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { forwardRef, useRef } from 'react';
import { ClearIcon } from '../../../../components/SearchForm/components/ClearIcon.js';
import { FieldChrome } from '../../../../components/SearchForm/components/FieldChrome/index.js';
import { TextField } from '../../../../primitives/index.js';
import { qaId } from '../../../../utils/index.js';
import { SEARCH_FORM_QA_ID } from '../../../../utils/qaId.js';
export const DestinationField = forwardRef(function DestinationField({
  value,
  active,
  invalid = false,
  disabled = false,
  clearable = false,
  onClear,
  layout = 'full',
  ...restProps
}, ref) {
  const {
    t
  } = useTranslation();
  const lgUp = useBreakpointUp('lg');
  const inputRef = useRef(null);
  if (layout === 'full' && lgUp) {
    // @ts-expect-error TS2339
    const handleFocus = () => inputRef?.current && inputRef.current.focus();
    return _jsx(FieldChrome, {
      ref: ref,
      // @ts-expect-error TS2322
      onClick: handleFocus,
      visuallyFocused: active,
      invalid: invalid,
      label: t('searchForm:searchField.placeholder'),
      prependIcon: _jsx(IconSearch, {}),
      appendIcon: clearable && value && active ? _jsx(ClearIcon
      // Fixes weird onClick behaviour (it only fires when dev tools are open)
      // TODO Investigate why
      , {
        // Fixes weird onClick behaviour (it only fires when dev tools are open)
        // TODO Investigate why
        onMouseDown: onClear,
        onClick: onClear,
        "data-cy": qaId(SEARCH_FORM_QA_ID, 'destinationField', 'deleteValue'),
        "data-testid": qaId(SEARCH_FORM_QA_ID, 'destinationField', 'deleteValue')
      }) : undefined,
      children: _jsx(TextField, {
        ...restProps,
        value: value,
        inputRef: inputRef,
        placeholder: t('searchForm:searchField.placeholderCompact'),
        "data-testid": "destination-field",
        "data-cy": qaId(SEARCH_FORM_QA_ID, 'destinationField'),
        style: {
          fontWeight: value ? '600' : 'inherit',
          color: active ? '#0e97c2' : 'inherit'
        }
      })
    });
  }
  return _jsx(FieldChrome, {
    ...restProps,
    ref: ref,
    layout: layout,
    value: value,
    visuallyFocused: active,
    invalid: invalid,
    label: t('searchForm:searchField.placeholder'),
    placeholder: t('searchForm:searchField.placeholderCompact'),
    prependIcon: _jsx(IconSearch, {})
  });
});